import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { environment } from '../../../../environments/environment';
import { BehaviorSubject, Observable, Subject, throwError } from 'rxjs';
import { FileTypeT3 } from '../../enums/user/file-type';
import {
  SelfAssessmentT3AllFilterDropdownDto,
  overallAssessmentDropdownList,
} from '../../models/self-assessmentT3/overallDropdownList';
import { SelfAssessmentDocumentModel } from '../../models/self-assessment/self-assessment-document-model';
import { SelfAssessmentCkDataSaveT3Dto } from '../../models/self-assessmentT3/overall-aseesment';
import { SelfAssessmentInterpretation } from '../../models/self-assessmentT3/SelfAssessmentInterpretation';
import { SelfAssessmentT3ViewModel } from '../../models/self-assessmentT3/SelfAssessmentT3ViewModel';
import {
  SelfAssessmentT3FilterModel,
  rightsManagementSAT3Dto,
} from '../../models/self-assessmentT3/SelfAssessmentT3Filter';
import { SelfAssessmentJudgement } from '../../models/self-assessmentT3/SelefassessmentJudgement';
import { SelfAssessmentT3ApproachDto } from '../../models/self-assessmentT3/SelfAssessmentApproach';
import {
  conditionalApprovalAssessmentData,
  interpretationAssessmentDto,
  reviewAssessmentData,
  approvalsAssessmentData,
  judgementAssessmentDto,
  ApproachAssessmentDto,
  overAllAssessmentSaveData,
  overAllReviewSaveData,
  overAllApprovalSaveData,
} from '../../models/self-assessmentT3/saveDataModel';
import { ItemInfoDto } from '../../models/rulebook/item.info-dto';
import { VersionHistoryFilter } from '../../models/self-assessment/version-history-filter';
import { VersionHistoryT3ViewModel } from '../../models/self-assessmentT3/version-filter-viewT3-model';
import { VersionHistoryViewModel } from '../../models/self-assessment/version-history';
import { TimeSpentModel } from '../../models/self-assessment/timespent-model';
import { SelfAssessmentT3KeyInformationSummaryDto } from '../../models/self-assessmentT3/selfassessmentKeyInformation';
import { catchError } from 'rxjs/operators';
@Injectable({
  providedIn: 'root',
})
export class SelfAssessmentTemplate3Service {
  constructor(private http: HttpClient) {}

  getT3OverAllAssessment(id: string): Observable<any> {
    let headers = new HttpHeaders();
    headers = headers.set('Content-Type', 'application/json; charset=utf-8');
    return this.http.get<any>(
      `${environment.config.baseAppURL}/SelfAssesmentT3/GetSelfAssessmentT3OverallAssessment?id=${id}`,
      { headers }
    );
  }

  getT3SummaryAssessment(id: number): Observable<any> {
    let headers = new HttpHeaders();
    headers = headers.set('Content-Type', 'application/json; charset=utf-8');
    return this.http.get<any>(
      `${environment.config.baseAppURL}/SelfAssesmentT3/GetSelfAssessmentT3Summary?id=${id}`,
      { headers }
    );
  }
  getTKeyInformationAssessment(id: number): Observable<any> {
    let headers = new HttpHeaders();
    headers = headers.set('Content-Type', 'application/json; charset=utf-8');
    return this.http.get<any>(
      `${environment.config.baseAppURL}/SelfAssesmentT3/GetSelfAssessmentT3KeyInformation?id=${id}`,
      { headers }
    );
  }

  getT3Interpretation(id: number): Observable<any> {
    let headers = new HttpHeaders();
    headers = headers.set('Content-Type', 'application/json; charset=utf-8');
    return this.http.get<SelfAssessmentInterpretation>(
      `${environment.config.baseAppURL}/SelfAssesmentT3/GetSelfAssessmentT3Interpretations?id=${id}`,
      { headers }
    );
  }
  getSelfAssessmentT3InterpretationDocument(
    id: number
  ): Observable<SelfAssessmentDocumentModel[]> {
    let headers = new HttpHeaders();
    headers = headers.set('Content-Type', 'application/json; charset=utf-8');
    // tslint:disable-next-line:max-line-length
    return this.http.get<SelfAssessmentDocumentModel[]>(
      `${environment.config.baseAppURL}/SelfAssesmentT3/GetSelfAssessmentT3InterpretationDocument?id=` +
        id,
      { headers }
    );
  }
  getSelfAssessmentT3JudgementDocument(
    id: number
  ): Observable<SelfAssessmentDocumentModel[]> {
    let headers = new HttpHeaders();
    headers = headers.set('Content-Type', 'application/json; charset=utf-8');
    // tslint:disable-next-line:max-line-length
    return this.http.get<SelfAssessmentDocumentModel[]>(
      `${environment.config.baseAppURL}/SelfAssesmentT3/GetSelfAssessmentT3JudgementDocument?id=` +
        id,
      { headers }
    );
  }
  getT3InterpretationAssessmentDropdowns(): Observable<overallAssessmentDropdownList> {
    let headers = new HttpHeaders();
    headers = headers.set('Content-Type', 'application/json; charset=utf-8');
    return this.http.get<overallAssessmentDropdownList>(
      `${environment.config.baseAppURL}/SelfAssesmentT3/GetT3InperpertationDropdownList`,
      { headers }
    );
  }
  addAdditionalInterpretationAssessment(id: number): Observable<any> {
    let headers = new HttpHeaders();
    headers = headers.set('Content-Type', 'application/json; charset=utf-8');
    // return this.http.post<any>(
    //   `${environment.config.baseAppURL}/SelfAssesmentT3/AddAdditionalInterpretation`,id,
    //   { headers }
    return this.http.post<any>(
      `${environment.config.baseAppURL}/SelfAssesmentT3/AddAdditionalInterpretation?summaryDetailsId=` +
        id,
      { headers }
    );
  }
  getAllInterpretationAssessmentById(
    summaryDetailsId: number
  ): Observable<any> {
    let headers = new HttpHeaders();
    headers = headers.set('Content-Type', 'application/json; charset=utf-8');
    return this.http.get<any>(
      `${environment.config.baseAppURL}/SelfAssesmentT3/GetSelfAssessmentT3InterpretationsList?summaryDetailsId=${summaryDetailsId}`,
      { headers }
    );
  }

  UploadEvidenceT3(
    fileToUpload: File,
    fileType: FileTypeT3,
    assessmentId: string
  ): Observable<any> {
    const formData: FormData = new FormData();
    formData.append('fileKey', fileToUpload, fileToUpload.name);
    let headers = new HttpHeaders();
    headers = headers.set('request', fileType.toString() + ';' + assessmentId);
    return this.http.post<any>(
      `${environment.config.baseAppURL}/SelfAssesmentT3/UploadEvidenceFileT3`,
      formData,
      { headers }
    );
  }

  UploadEvidenceInterpretationT3(
    fileToUpload: File,
    fileType: FileTypeT3,
    assessmentId: string
  ): Observable<any> {
    const formData: FormData = new FormData();
    formData.append('fileKey', fileToUpload, fileToUpload.name);
    let headers = new HttpHeaders();
    headers = headers.set('request', fileType.toString() + ';' + assessmentId);
    return this.http.post<any>(
      `${environment.config.baseAppURL}/SelfAssesmentT3/UploadInterpretationEvidenceFileT3`,
      formData,
      { headers }
    );
  }
  UploadEvidenceJudgementT3(
    fileToUpload: File,
    fileType: FileTypeT3,
    assessmentId: string
  ): Observable<any> {
    const formData: FormData = new FormData();
    formData.append('fileKey', fileToUpload, fileToUpload.name);
    let headers = new HttpHeaders();
    headers = headers.set('request', fileType.toString() + ';' + assessmentId);
    return this.http.post<any>(
      `${environment.config.baseAppURL}/SelfAssesmentT3/UploadJudgementEvidenceFileT3`,
      formData,
      { headers }
    );
  }

  getT3OverAllAssessmentDropdowns(): Observable<overallAssessmentDropdownList> {
    let headers = new HttpHeaders();
    headers = headers.set('Content-Type', 'application/json; charset=utf-8');
    return this.http.get<overallAssessmentDropdownList>(
      `${environment.config.baseAppURL}/SelfAssesmentT3/GetT3OverallAllDropdownList`,
      { headers }
    );
  }

  getSelfAssessmentT3OverallDocuments(
    id: number
  ): Observable<SelfAssessmentDocumentModel[]> {
    let headers = new HttpHeaders();
    headers = headers.set('Content-Type', 'application/json; charset=utf-8');
    // tslint:disable-next-line:max-line-length
    return this.http.get<SelfAssessmentDocumentModel[]>(
      `${environment.config.baseAppURL}/SelfAssesmentT3/GetSelfAssessmentT3OverallDocument?id=` +
        id,
      { headers }
    );
  }

  deleteSelfAssessmentT3Document(id: number): Observable<any> {
    let headers = new HttpHeaders();
    headers = headers.set('Content-Type', 'application/json; charset=utf-8');
    return this.http.get<any>(
      `${environment.config.baseAppURL}/SelfAssesmentT3/DeleteSelfAssessmentT3Document?id=` +
        id,
      { headers }
    );
  }
  deleteSelfAssessmentInterpretationT3Document(id: number): Observable<any> {
    let headers = new HttpHeaders();
    headers = headers.set('Content-Type', 'application/json; charset=utf-8');
    return this.http.get<any>(
      `${environment.config.baseAppURL}/SelfAssesmentT3/DeleteSelfAssessmentT3InterpretationDocument?id=` +
        id,
      { headers }
    );
  }
  deleteSelfAssessmentJudgementT3Document(id: number): Observable<any> {
    let headers = new HttpHeaders();
    headers = headers.set('Content-Type', 'application/json; charset=utf-8');
    return this.http.get<any>(
      `${environment.config.baseAppURL}/SelfAssesmentT3/DeleteSelfAssessmentT3JudgementDocument?id=` +
        id,
      { headers }
    );
  }
  downloadEvidenceT3(id: number): Observable<any> {
    let headers = new HttpHeaders();
    headers = headers
      .set('Content-Type', 'application/json; charset=utf-8')
      .set('request', id.toString());
    return this.http.get(
      `${environment.config.baseAppURL}/SelfAssesmentT3/DownloadEvidenceT3`,
      { headers, responseType: 'blob' }
    );
  }
  downloadEvidenceInterpretationT3(id: number): Observable<any> {
    let headers = new HttpHeaders();
    headers = headers
      .set('Content-Type', 'application/json; charset=utf-8')
      .set('request', id.toString());
    return this.http.get(
      `${environment.config.baseAppURL}/SelfAssesmentT3/DownloadInterpretationEvidenceT3`,
      { headers, responseType: 'blob' }
    );
  }
  downloadEvidenceJudgementT3(id: number): Observable<any> {
    let headers = new HttpHeaders();
    headers = headers
      .set('Content-Type', 'application/json; charset=utf-8')
      .set('request', id.toString());
    return this.http.get(
      `${environment.config.baseAppURL}/SelfAssesmentT3/DownloadJudgementEvidenceT3`,
      { headers, responseType: 'blob' }
    );
  }
  updateSelfAssessmentCKT3(
    data: SelfAssessmentCkDataSaveT3Dto
  ): Observable<any> {
    let headers = new HttpHeaders();
    headers = headers.set('Content-Type', 'application/json; charset=utf-8');
    return this.http.post<any>(
      `${environment.config.baseAppURL}/SelfAssesmentT3/UpdateSelfAssessmentOverAllAssessmentCKT3`,
      data,
      { headers }
    );
  }
  updateSelfAssessmentCKForInterpretationT3(
    data: SelfAssessmentCkDataSaveT3Dto
  ): Observable<any> {
    let headers = new HttpHeaders();
    headers = headers.set('Content-Type', 'application/json; charset=utf-8');
    return this.http.post<any>(
      `${environment.config.baseAppURL}/SelfAssesmentT3/UpdateInterpretationCKEditor`,
      data,
      { headers }
    );
  }

  addAdditionalJudgeMent(id: number): Observable<any> {
    let headers = new HttpHeaders();
    headers = headers.set('Content-Type', 'application/json; charset=utf-8');
    // return this.http.post<any>(
    //   `${environment.config.baseAppURL}/SelfAssesmentT3/AddAdditionalInterpretation`,id,
    //   { headers }
    return this.http.post<any>(
      `${environment.config.baseAppURL}/SelfAssesmentT3/AddAdditionalJudgement?summaryDetailsId=` +
        id,
      { headers }
    );
  }
  getAllJudgmentsById(summaryDetailsId: number): Observable<any> {
    let headers = new HttpHeaders();
    headers = headers.set('Content-Type', 'application/json; charset=utf-8');
    return this.http.get<any>(
      `${environment.config.baseAppURL}/SelfAssesmentT3/GetSelfAssessmentT3JudgementList?summaryDetailsId=${summaryDetailsId}`,
      { headers }
    );
  }
  getT3Judgement(id: number): Observable<any> {
    let headers = new HttpHeaders();
    headers = headers.set('Content-Type', 'application/json; charset=utf-8');
    return this.http.get<any>(
      `${environment.config.baseAppURL}/SelfAssesmentT3/GetSelfAssessmentT3Judgements?id=${id}`,
      { headers }
    );
  }
  deleteSummaryT3(id: number[]): Observable<any> {
    let headers = new HttpHeaders();
    headers = headers
      .set('Content-Type', 'application/json; charset=utf-8')
      .set('request', JSON.stringify(id));
    return this.http.get<any>(
      `${environment.config.baseAppURL}/SelfAssesmentT3/DeleteSelfAssessmentT3Details`,

      { headers }
    );
  }
  updateSelfAssessmentCKForJudgementT3(
    data: SelfAssessmentCkDataSaveT3Dto
  ): Observable<any> {
    let headers = new HttpHeaders();
    headers = headers.set('Content-Type', 'application/json; charset=utf-8');
    return this.http.post<any>(
      `${environment.config.baseAppURL}/SelfAssesmentT3/UpdateJudgementCKEditor`,
      data,
      { headers }
    );
  }
  saveInterpretationT3(data: SelfAssessmentInterpretation): Observable<any> {
    let headers = new HttpHeaders();
    headers = headers.set('Content-Type', 'application/json; charset=utf-8');
    return this.http.post<any>(
      `${environment.config.baseAppURL}/SelfAssesmentT3/UpdateInterpretation`,
      data,
      { headers }
    );
  }
  saveJudgementT3(data: SelfAssessmentJudgement): Observable<any> {
    let headers = new HttpHeaders();
    headers = headers.set('Content-Type', 'application/json; charset=utf-8');
    return this.http.post<any>(
      `${environment.config.baseAppURL}/SelfAssesmentT3/UpdateJudgement`,
      data,
      { headers }
    );
  }
  getSelfAssessmentT3List(
    filter: SelfAssessmentT3FilterModel
  ): Observable<SelfAssessmentT3ViewModel> {
    let headers = new HttpHeaders();
    headers = headers
      .set('Content-Type', 'application/json; charset=utf-8')
      .set('request', JSON.stringify(filter));
    return this.http.get<SelfAssessmentT3ViewModel>(
      `${environment.config.baseAppURL}/SelfAssesmentT3/GetSelfAssessmentT3List`,
      { headers }
    );
  }

  //approaches
  getAllApproachAssessmentById(summaryDetailsId: number): Observable<any> {
    let headers = new HttpHeaders();
    headers = headers.set('Content-Type', 'application/json; charset=utf-8');
    return this.http.get<any>(
      `${environment.config.baseAppURL}/SelfAssesmentT3/GetSelfAssessmentT3ApproachList?summaryDetailsId=${summaryDetailsId}`,
      { headers }
    );
  }
  getT3Approaches(id: number): Observable<any> {
    let headers = new HttpHeaders();
    headers = headers.set('Content-Type', 'application/json; charset=utf-8');
    return this.http.get<any>(
      `${environment.config.baseAppURL}/SelfAssesmentT3/GetSelfAssessmentT3Approach?id=${id}`,
      { headers }
    );
  }
  updateSelfAssessmentCKForApproachT3(
    data: SelfAssessmentCkDataSaveT3Dto
  ): Observable<any> {
    let headers = new HttpHeaders();
    headers = headers.set('Content-Type', 'application/json; charset=utf-8');
    return this.http.post<any>(
      `${environment.config.baseAppURL}/SelfAssesmentT3/UpdateApproachCKEditor`,
      data,
      { headers }
    );
  }
  addAdditionalApproach(id: number): Observable<any> {
    let headers = new HttpHeaders();
    headers = headers.set('Content-Type', 'application/json; charset=utf-8');
    return this.http.post<any>(
      `${environment.config.baseAppURL}/SelfAssesmentT3/AddAdditionalApproach?summaryDetailsId=` +
        id,
      { headers }
    );
  }
  saveApproachDataT3(data: SelfAssessmentT3ApproachDto): Observable<any> {
    let headers = new HttpHeaders();
    headers = headers.set('Content-Type', 'application/json; charset=utf-8');
    return this.http.post<any>(
      `${environment.config.baseAppURL}/SelfAssesmentT3/UpdateApproach`,
      data,
      { headers }
    );
  }

  UploadEvidenceApproachT3(
    fileToUpload: File,
    fileType: FileTypeT3,
    assessmentId: string
  ): Observable<any> {
    const formData: FormData = new FormData();
    formData.append('fileKey', fileToUpload, fileToUpload.name);
    let headers = new HttpHeaders();
    headers = headers.set('request', fileType.toString() + ';' + assessmentId);
    return this.http.post<any>(
      `${environment.config.baseAppURL}/SelfAssesmentT3/UploadApproachEvidenceFileT3`,
      formData,
      { headers }
    );
  }
  getSelfAssessmentT3ApproachDocument(
    id: number
  ): Observable<SelfAssessmentDocumentModel[]> {
    let headers = new HttpHeaders();
    headers = headers.set('Content-Type', 'application/json; charset=utf-8');
    return this.http.get<SelfAssessmentDocumentModel[]>(
      `${environment.config.baseAppURL}/SelfAssesmentT3/GetSelfAssessmentT3ApproachDocument?id=` +
        id,
      { headers }
    );
  }
  downloadEvidenceApproachT3(id: number): Observable<any> {
    let headers = new HttpHeaders();
    headers = headers
      .set('Content-Type', 'application/json; charset=utf-8')
      .set('request', id.toString());
    return this.http.get(
      `${environment.config.baseAppURL}/SelfAssesmentT3/DownloadApproachEvidenceT3`,
      { headers, responseType: 'blob' }
    );
  }
  deleteSelfAssessmentApproachT3Document(id: number): Observable<any> {
    let headers = new HttpHeaders();
    headers = headers.set('Content-Type', 'application/json; charset=utf-8');
    return this.http.get<any>(
      `${environment.config.baseAppURL}/SelfAssesmentT3/DeleteSelfAssessmentT3ApproaachDocument?id=` +
        id,
      { headers }
    );
  }

  private triggerCkEditorChildFunctionSource = new Subject<void>();

  triggerCkEditorChildFunction$ =
    this.triggerCkEditorChildFunctionSource.asObservable();

  async triggerCkEditorChildFunctionAsync() {
    return new Promise<void>((resolve, reject) => {
      this.triggerCkEditorChildFunctionSource.next();
      resolve();
    });
  }
  // Interpretation
  saveInterpretationT3AssessmentData(
    data: interpretationAssessmentDto,
    currentUrl: string
  ): Observable<any> {
    let headers = new HttpHeaders();
    headers = headers
      .set('Content-Type', 'application/json; charset=utf-8')
      .set('CurrentUrl', currentUrl);
    return this.http.post<any>(
      `${environment.config.baseAppURL}/SelfAssesmentT3/UpdateInterpretationAssessmentData`,
      data,
      { headers }
    );
  }
  // saveInterpretationT3ReviewData(
  //   data: reviewAssessmentData,
  //   currentUrl: string
  // ): Observable<any> {
  //   let headers = new HttpHeaders();
  //   headers = headers
  //     .set('Content-Type', 'application/json; charset=utf-8')
  //     .set('CurrentUrl', currentUrl);
  //   return this.http.post<any>(
  //     `${environment.config.baseAppURL}/SelfAssesmentT3/UpdateInterpretationReviewData`,
  //     data,
  //     { headers }
  //   );
  // }
  saveInterpretationT3ReviewData(data: reviewAssessmentData, currentUrl: string): Observable<any> {
    let headers = new HttpHeaders();
    headers = headers
      .set('Content-Type', 'application/json; charset=utf-8')
      .set('CurrentUrl', currentUrl);
      
    return this.http.post<any>(
      `${environment.config.baseAppURL}/SelfAssesmentT3/UpdateInterpretationReviewData`,
      data,
      { headers }
    ).pipe(
      catchError(this.handleError)
    );
  }
  private handleError(error: any) {
    return throwError(error.error ? error.error : 'Server error');
  }

  saveInterpretationT3ConditionalApprovalData(
    data: conditionalApprovalAssessmentData,
    currentUrl: string
  ): Observable<any> {
    let headers = new HttpHeaders();
    headers = headers
      .set('Content-Type', 'application/json; charset=utf-8')
      .set('CurrentUrl', currentUrl);
    return this.http.post<any>(
      `${environment.config.baseAppURL}/SelfAssesmentT3/UpdateInterpretationConditionalApprovalData`,
      data,
      { headers }
    );
  }
  saveInterpretationApprovalsData(
    data: approvalsAssessmentData,
    currentUrl: string
  ): Observable<any> {
    let headers = new HttpHeaders();
    headers = headers
      .set('Content-Type', 'application/json; charset=utf-8')
      .set('CurrentUrl', currentUrl);
    return this.http.post<any>(
      `${environment.config.baseAppURL}/SelfAssesmentT3/UpdateInterpretationApprovalsData`,
      data,
      { headers }
    ).pipe(
      catchError(this.handleError)
    );
  }
  // Judgement
  saveJudgementT3AssessmentData(
    data: judgementAssessmentDto,
    currentUrl: string
  ): Observable<any> {
    let headers = new HttpHeaders();
    headers = headers
      .set('Content-Type', 'application/json; charset=utf-8')
      .set('CurrentUrl', currentUrl);
    return this.http.post<any>(
      `${environment.config.baseAppURL}/SelfAssesmentT3/UpdateJudgementAssessmentData`,
      data,
      { headers }
    );
  }
  saveJudgementT3ReviewData(
    data: reviewAssessmentData,
    currentUrl: string
  ): Observable<any> {
    let headers = new HttpHeaders();
    headers = headers
      .set('Content-Type', 'application/json; charset=utf-8')
      .set('CurrentUrl', currentUrl);
    return this.http.post<any>(
      `${environment.config.baseAppURL}/SelfAssesmentT3/UpdateJudgementReviewData`,
      data,
      { headers }
    ).pipe(
      catchError(this.handleError)
    );
  }
  saveJudgementApprovalsData(
    data: approvalsAssessmentData,
    currentUrl: string
  ): Observable<any> {
    let headers = new HttpHeaders();
    headers = headers
      .set('Content-Type', 'application/json; charset=utf-8')
      .set('CurrentUrl', currentUrl);
    return this.http.post<any>(
      `${environment.config.baseAppURL}/SelfAssesmentT3/UpdateJudgementApprovalsData`,
      data,
      { headers }
    ).pipe(
      catchError(this.handleError)
    );;
  }
  saveJudgementT3ConditionalApprovalData(
    data: conditionalApprovalAssessmentData,
    currentUrl: string
  ): Observable<any> {
    let headers = new HttpHeaders();
    headers = headers
      .set('Content-Type', 'application/json; charset=utf-8')
      .set('CurrentUrl', currentUrl);
    return this.http.post<any>(
      `${environment.config.baseAppURL}/SelfAssesmentT3/UpdateJudgementConditionalApprovalData`,
      data,
      { headers }
    );
  }
  // Approach
  saveApproach3AssessmentData(
    data: ApproachAssessmentDto,
    currentUrl: string
  ): Observable<any> {
    let headers = new HttpHeaders();
    headers = headers
      .set('Content-Type', 'application/json; charset=utf-8')
      .set('CurrentUrl', currentUrl);
    return this.http.post<any>(
      `${environment.config.baseAppURL}/SelfAssesmentT3/UpdateApproachAssessmentData`,
      data,
      { headers }
    );
  }
  saveApproachT3ReviewData(
    data: reviewAssessmentData,
    currentUrl: string
  ): Observable<any> {
    let headers = new HttpHeaders();
    headers = headers
      .set('Content-Type', 'application/json; charset=utf-8')
      .set('CurrentUrl', currentUrl);
    return this.http.post<any>(
      `${environment.config.baseAppURL}/SelfAssesmentT3/UpdateApproachReviewData`,
      data,
      { headers }
    ).pipe(
      catchError(this.handleError)
    );
  }
  saveApproachApprovalsData(
    data: approvalsAssessmentData,
    currentUrl: string
  ): Observable<any> {
    let headers = new HttpHeaders();
    headers = headers
      .set('Content-Type', 'application/json; charset=utf-8')
      .set('CurrentUrl', currentUrl);
    return this.http.post<any>(
      `${environment.config.baseAppURL}/SelfAssesmentT3/UpdateApproachApprovalsData`,
      data,
      { headers }
    ).pipe(
      catchError(this.handleError)
    );
  }
  saveApproachT3ConditionalApprovalData(
    data: conditionalApprovalAssessmentData,
    currentUrl: string
  ): Observable<any> {
    let headers = new HttpHeaders();
    headers = headers
      .set('Content-Type', 'application/json; charset=utf-8')
      .set('CurrentUrl', currentUrl);
    return this.http.post<any>(
      `${environment.config.baseAppURL}/SelfAssesmentT3/UpdateApproachConditionalApprovalData`,
      data,
      { headers }
    );
  }
  //overall assessment save
  updateSelfAssessmentOverallAssesssmentT3(
    data: overAllAssessmentSaveData,
    currentUrl: string
  ) {
    let headers = new HttpHeaders();
    headers = headers
      .set('Content-Type', 'application/json; charset=utf-8')
      .set('CurrentUrl', currentUrl);
    return this.http.post<any>(
      `${environment.config.baseAppURL}/SelfAssesmentT3/UpdateSelfAssessmentT3OverallAssessment`,
      data,
      { headers }
    );
  }
  updateSelfAssessmentOverallReviewT3(
    data: overAllReviewSaveData,
    currentUrl: string
  ) {
    let headers = new HttpHeaders();
    headers = headers
      .set('Content-Type', 'application/json; charset=utf-8')
      .set('CurrentUrl', currentUrl);
    return this.http.post<any>(
      `${environment.config.baseAppURL}/SelfAssesmentT3/UpdateSelfAssessmentT3OverallReview`,
      data,
      { headers }
    );
  }
  updateSelfAssessmentOverallApprovalsT3(
    data: overAllApprovalSaveData,
    currentUrl: string
  ) {
    let headers = new HttpHeaders();
    headers = headers
      .set('Content-Type', 'application/json; charset=utf-8')
      .set('CurrentUrl', currentUrl);
    return this.http.post<any>(
      `${environment.config.baseAppURL}/SelfAssesmentT3/UpdateSelfAssessmentT3OverallApprovals`,
      data,
      { headers }
    );
  }
  addSelfAssessmentT3(itemInfoDto: ItemInfoDto): Observable<string> {
    let headers = new HttpHeaders();
    headers = headers.set('Content-Type', 'application/json; charset=utf-8');
    // tslint:disable-next-line:max-line-length
    return this.http.post<string>(
      `${environment.config.baseAppURL}/SelfAssesmentT3/AddSelfAssessmentT3`,
      itemInfoDto,
      { headers }
    );
  }
  // bulk update
  bulkUpdatepdateSelfAssessmentT3(
    data: overAllAssessmentSaveData,
    selectedItems: number[]
  ) {
    let headers = new HttpHeaders();
    headers = headers.set('Content-Type', 'application/json; charset=utf-8');
    return this.http.post<any>(
      `${environment.config.baseAppURL}/SelfAssesmentT3/BulkUpdateSelfAssessmentT3`,
      {
        updateSelfAssessment: data,
        selectedItems: selectedItems,
      },
      { headers }
    );
  }
  bulkUpdatepdateSelfAssessmentT3Review(
    data: overAllReviewSaveData,
    selectedItems: number[]
  ) {
    let headers = new HttpHeaders();
    headers = headers.set('Content-Type', 'application/json; charset=utf-8');
    return this.http.post<any>(
      `${environment.config.baseAppURL}/SelfAssesmentT3/BulkUpdateSelfAssessmentT3Review`,
      {
        updateSelfAssessment: data,
        selectedItems: selectedItems,
      },
      { headers }
    );
  }
  bulkUpdatepdateSelfAssessmentT3Action(
    data: overAllApprovalSaveData,
    selectedItems: number[]
  ) {
    let headers = new HttpHeaders();
    headers = headers.set('Content-Type', 'application/json; charset=utf-8');
    return this.http.post<any>(
      `${environment.config.baseAppURL}/SelfAssesmentT3/BulkUpdateSelfAssessmentT3Action`,
      {
        updateSelfAssessment: data,
        selectedItems: selectedItems,
      },
      { headers }
    );
  }

  //Overall Assessment Version History
  getOverallVersionHistoryT3(
    filter: VersionHistoryFilter
  ): Observable<VersionHistoryViewModel> {
    let headers = new HttpHeaders();
    headers = headers
      .set('Content-Type', 'application/json; charset=utf-8')
      .set('request', JSON.stringify(filter));
    return this.http.get<VersionHistoryViewModel>(
      `${environment.config.baseAppURL}/SelfAssesmentT3/GetVersionHistoryT3Overall`,
      { headers }
    );
  }
  getOverallAssessmentVersionHistoryDetails(id: number): Observable<any> {
    let headers = new HttpHeaders();
    headers = headers.set('Content-Type', 'application/json; charset=utf-8');
    return this.http.get<any>(
      `${environment.config.baseAppURL}/SelfAssesmentT3/GetSelfAssessmentT3OverallAssessmentVersionHistoryDetails?id=${id}`,
      { headers }
    );
  }
  //interpretation version history
  getInterpretationVersionHistoryT3(
    filter: VersionHistoryFilter
  ): Observable<VersionHistoryViewModel> {
    let headers = new HttpHeaders();
    headers = headers
      .set('Content-Type', 'application/json; charset=utf-8')
      .set('request', JSON.stringify(filter));
    return this.http.get<VersionHistoryViewModel>(
      `${environment.config.baseAppURL}/SelfAssesmentT3/GetVersionHistoryT3Interpretation`,
      { headers }
    );
  }
  getInterpretationVersionHistoryDetails(id: number): Observable<any> {
    let headers = new HttpHeaders();
    headers = headers.set('Content-Type', 'application/json; charset=utf-8');
    return this.http.get<any>(
      `${environment.config.baseAppURL}/SelfAssesmentT3/GetSelfAssessmentT3InterpretationVersionHistoryDetails?id=${id}`,
      { headers }
    );
  }
  //judgement version history
  getjudgementVersionHistoryT3(
    filter: VersionHistoryFilter
  ): Observable<VersionHistoryViewModel> {
    let headers = new HttpHeaders();
    headers = headers
      .set('Content-Type', 'application/json; charset=utf-8')
      .set('request', JSON.stringify(filter));
    return this.http.get<VersionHistoryViewModel>(
      `${environment.config.baseAppURL}/SelfAssesmentT3/GetVersionHistoryT3Judgement`,
      { headers }
    );
  }
  getJudgementVersionHistoryDetails(id: number): Observable<any> {
    let headers = new HttpHeaders();
    headers = headers.set('Content-Type', 'application/json; charset=utf-8');
    return this.http.get<any>(
      `${environment.config.baseAppURL}/SelfAssesmentT3/GetSelfAssessmentT3JudgementVersionHistoryDetails?id=${id}`,
      { headers }
    );
  }
  //approach virsion history
  getapproachVersionHistoryT3(
    filter: VersionHistoryFilter
  ): Observable<VersionHistoryViewModel> {
    let headers = new HttpHeaders();
    headers = headers
      .set('Content-Type', 'application/json; charset=utf-8')
      .set('request', JSON.stringify(filter));
    return this.http.get<VersionHistoryViewModel>(
      `${environment.config.baseAppURL}/SelfAssesmentT3/GetVersionHistoryT3Approach`,
      { headers }
    );
  }
  getApproachVersionHistoryDetails(id: number): Observable<any> {
    let headers = new HttpHeaders();
    headers = headers.set('Content-Type', 'application/json; charset=utf-8');
    return this.http.get<any>(
      `${environment.config.baseAppURL}/SelfAssesmentT3/GetSelfAssessmentT3ApproachVersionHistoryDetails?id=${id}`,
      { headers }
    );
  }
  getKeyInformationSummury(
    summaryDetailsId: number
  ): Observable<SelfAssessmentT3KeyInformationSummaryDto> {
    let headers = new HttpHeaders();
    headers = headers.set('Content-Type', 'application/json; charset=utf-8');
    return this.http.get<SelfAssessmentT3KeyInformationSummaryDto>(
      `${environment.config.baseAppURL}/SelfAssesmentT3/GetKeyInformationSummury?SummaryDetailsId=${summaryDetailsId}`,
      { headers }
    );
  }
  //TimeSpent Work
  updateTimeSpent(timeSpent: TimeSpentModel): Observable<any> {
    let headers = new HttpHeaders();
    headers = headers.set('Content-Type', 'application/json; charset=utf-8');
    return this.http.post<any>(
      `${environment.config.baseAppURL}/SelfAssesmentT3/UpdateTimeSpent`,
      timeSpent,
      { headers }
    );
  }
  // SA-T3 filter dropdown
  getT3OverAllAssessmentDropdownFilter(
    jurisdictionId: number
  ): Observable<SelfAssessmentT3AllFilterDropdownDto> {
    let headers = new HttpHeaders();
    headers = headers.set('Content-Type', 'application/json; charset=utf-8');
    return this.http.get<SelfAssessmentT3AllFilterDropdownDto>(
      `${environment.config.baseAppURL}/SelfAssesmentT3/GetT3OverallAllFilterDropdownList?JurisdictionId=${jurisdictionId}`,
      { headers }
    );
  }
  // Send Notification
  getT3SummarySendNotification(
    isSendNotification: boolean,
    id: number
  ): Observable<boolean> {
    let headers = new HttpHeaders();
    headers = headers.set('Content-Type', 'application/json; charset=utf-8');
    return this.http.post<boolean>(
      `${environment.config.baseAppURL}/SelfAssesmentT3/GetT3SummarySendNotification?IsSendNotification=${isSendNotification}&Id=${id}`,
      { headers }
    );
  }
  getSelfAssessmentT3UserPermission(
    userName: string,
    assessmentId: number,
    tableName: string,
    subId: number
  ): Observable<rightsManagementSAT3Dto> {
    let headers = new HttpHeaders();
    headers = headers.set('Content-Type', 'application/json; charset=utf-8');
    return this.http.post<rightsManagementSAT3Dto>(
      `${environment.config.baseAppURL}/SelfAssesmentT3/GetSelfAssessmentT3UserPermission`,
      {
        userName: userName,
        assessmentId: assessmentId,
        tableName: tableName,
        subId: subId,
      },
      { headers }
    );
  }
}
